import { COMPANY, NAV_LINKS } from "@/lib/data";
import { Download } from "lucide-react";

const BROCHURE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/brochure`;

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-bone border-t border-bone/15"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-9 h-9 bg-rust text-bone grid place-items-center font-heading font-black text-sm tracking-tighter">
                S
              </span>
              <div className="leading-none">
                <div className="font-heading font-black text-lg tracking-tight">
                  {COMPANY.name}
                </div>
                <div className="font-mono text-[10px] tracking-widest text-bone/55 uppercase">
                  EST. {COMPANY.established}
                </div>
              </div>
            </div>
            <p className="text-bone/65 text-sm leading-relaxed max-w-md">
              {COMPANY.tagline}
            </p>
            <a
              data-testid="footer-cta-brochure"
              href={BROCHURE_URL}
              download="SVP-INFRA-Brochure.pdf"
              className="mt-6 inline-flex items-center gap-2.5 border border-bone/40 text-bone px-5 py-3 font-mono text-xs uppercase tracking-[0.22em] hover:bg-rust hover:border-rust transition-colors"
            >
              <Download className="w-3.5 h-3.5" strokeWidth={2.5} />
              Download Brochure (PDF)
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-rust mb-4">
              Navigate
            </div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    data-testid={`footer-link-${l.id}`}
                    className="text-bone/80 hover:text-rust transition-colors text-sm"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-rust mb-4">
              Office
            </div>
            <address className="not-italic text-bone/75 text-sm leading-relaxed">
              {COMPANY.address}
            </address>
            <div className="mt-4 space-y-1 text-sm">
              {COMPANY.phones.map((p) => (
                <a
                  key={p}
                  href={`tel:${p.replace(/\s+/g, "")}`}
                  className="block text-bone hover:text-rust transition-colors"
                >
                  {p}
                </a>
              ))}
              <a
                href={`mailto:${COMPANY.email}`}
                className="block text-bone hover:text-rust transition-colors"
              >
                {COMPANY.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-bone/15 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="font-mono text-[11px] tracking-widest uppercase text-bone/50">
            © {year} {COMPANY.name}. All rights reserved.
          </div>
          <div className="font-mono text-[11px] tracking-widest uppercase text-bone/50">
            GSTIN: {COMPANY.gstin}
          </div>
        </div>
      </div>
    </footer>
  );
}
